import _ from 'lodash';
import {scopes} from '../../permissions/dictionary';

// Una opción de menú se muestra solo con el scope Visualizar del recurso (o una variante como
// 'Visualizar parcialmente'), nunca con Crear/Editar/Eliminar: así conceder un permiso de acción
// a un rol no le enciende menús. Los `scopes` declarados en cada opción ya no se evalúan.
const grantsView = (permissions = [], resource) => {
  const granted = _.find(permissions, {'rsname': resource});
  return Boolean(granted) && (granted.scopes || []).some(
    (scope) => scope === scopes.See || scope.startsWith(`${scopes.See} `));
};

export const filterByPermissions = (permissions, options = []) => {
  const filteredOptions = options.filter((item) => grantsView(permissions, item.resource));
  return filteredOptions.map((option) => ({'name': option.name, 'path': option.path, 'resource': option.resource}));
};

export const filterItemsWithOptions = (menuItems) => {
  return menuItems.filter((item) => item.options.length);
};
